export default "__VITE_ASSET__D9NT_84J__"